export const downloadFile = ({ fileName, fileType, fileUrl }) => {
  var xhr = new XMLHttpRequest();
  xhr.responseType = 'blob';
  xhr.onload = () => {
    const blob = new Blob([xhr.response], {
      type: fileType,
    });
    let a = document.createElement('a');
    a.style = 'display: none';
    document.body.appendChild(a);
    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  };
  xhr.open('GET', fileUrl);
  xhr.send();
};
